import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';

const StyledLoading = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: ${(props) => props.borderRadius};
  background-color: ${(props) => props.theme.inputBackground};
  position: relative;
  overflow: hidden;
`;

const StyledLoadingHelper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: ${(props) => props.borderRadius};
  position: absolute;
  overflow: hidden;
  clip-path: inset(0% 0% 0% 0% round 0px);
  backface-visibility: hidden;
  /* transform: translate3d(0,0,0); */
`;

const StyledLoadingBar = styled.div`
  width: 16vw;
  height: 100vh;
  border-radius: inherit;
  background-image: ${(props) =>
    'linear-gradient(90deg,' +
    props.theme.inputBackground +
    ',' +
    props.theme.borderBackground +
    ',' +
    props.theme.inputBackground +
    ')'};
  position: fixed;
  top: 0;
  overflow: hidden;
  animation: mymovei 1s linear infinite;
  @keyframes mymovei {
    from {
      left: -8vw;
    }
    to {
      left: 92vw;
    }
  }
`;

const Loading = (props) => {
  const { theme } = useContext(ThemeContext);
  const { width, height, borderRadius } = props;
  return (
    <StyledLoading width={width} height={height} borderRadius={borderRadius} theme={theme}>
      <StyledLoadingHelper borderRadius={borderRadius}>
        <StyledLoadingBar theme={theme} />
      </StyledLoadingHelper>
    </StyledLoading>
  );
};

export default Loading;
